/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Task_Email_DisabledInputs */

const en_api_error_task_email_disabled = /** @type {(inputs: Api_Error_Task_Email_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This task's settings do not email its assignee.`)
};

const pt_br2_api_error_task_email_disabled = /** @type {(inputs: Api_Error_Task_Email_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As configurações desta atividade não enviam e-mail ao responsável.`)
};

/**
* | output |
* | --- |
* | "This task's settings do not email its assignee." |
*
* @param {Api_Error_Task_Email_DisabledInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_task_email_disabled = /** @type {((inputs?: Api_Error_Task_Email_DisabledInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Task_Email_DisabledInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_task_email_disabled(inputs)
	return pt_br2_api_error_task_email_disabled(inputs)
});